import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from '../dropdown/dropdown.module';
import { InputContainerModule } from '../input-container/input-container.module';
import { TextInputModule } from '../text-input/text-input.module';
import { TextInputPhoneComponent } from './text-input-phone.component';

@NgModule({
  declarations: [TextInputPhoneComponent],
  imports: [
    CommonModule,
    InputContainerModule,
    TextInputModule,
    ReactiveFormsModule,
    DropdownModule,
    FormsModule,
  ],
  exports: [TextInputPhoneComponent],
})
export class TextInputPhoneModule {}
